import { motion } from "framer-motion";
import { Coins } from "lucide-react";
import { usePoints } from "@/hooks/usePoints";
import { useAuth } from "@/hooks/useAuth";
import { Link } from "react-router-dom";

const PointsBadge = () => {
  const { user } = useAuth();
  const { balance, isLoading } = usePoints();

  if (!user || isLoading) return null;

  return (
    <Link to="/נקודות">
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        className="flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary/10 text-primary text-xs font-bold cursor-pointer hover:bg-primary/20 transition-colors"
      >
        <Coins size={14} />
        <span>{balance.toLocaleString()}</span>
      </motion.div>
    </Link>
  );
};

export default PointsBadge;
